<div
  class="modal success-modal-backdrop"
  style="display: block !important; background: #0000007a"
  id="content"
>
  <div class="modal-dialog success-dialog">
    <div class="modal-content success-dialog-content">
      <div class="success-dialog-body">
        <div class="success-dialog-icon">
          <img alt="" src="/assets/images/fry-bucket.svg" />
        </div>

        <div class="success-dialog-title-row">
          <h4 class="success-dialog-title">{{ title }}</h4>
          <span class="success-check-icon" *ngIf="isSuccessState" aria-hidden="true">
            <img src="/assets/images/circle-check 1.svg" alt="Success" />
           
          </span>
        </div>

        <p class="success-dialog-message">{{ message }}</p>
      </div>

      <div class="success-dialog-footer">
        <button
          type="button"
          class="success-btn success-btn-close"
          (click)="closeDialog()"
        >
          {{ closeButtonLabel }}
        </button>
        <button
          type="button"
          class="success-btn success-btn-view"
          *ngIf="showViewButton"
          (click)="viewDialog()"
        >
          {{ viewButtonLabel }}
        </button>
      </div>
    </div>
  </div>
</div>
